let service = function (Http, $http, config, $q, $rootScope) {
	"ngInject";

	this.count = 0;
	this.get = () => Http.get('/v1/chat', false);
	this.send = (input) => Http.post('/v1/chat', 'POST', {
		input: input
	});

	this.setCount = (count) => {
		this.count = parseInt(count);
		$rootScope.$broadcast('support:count', this.count);
	}

	this.upload = (file) => {

		var options = new FileUploadOptions();
		options.fileKey = "file";
		options.fileName = file.substr(file.lastIndexOf('/') + 1);

		var ft = new FileTransfer();
		ft.upload(file, encodeURI(config.api+'/v1/chat/upload?token='+localStorage.getItem('satellizer_token')), win, fail, options);

		function win(res) {
			return $q.resolve(res);
		}

		function fail(err) {
			return $q.reject(err);
		}
	}

};

export default service;


// WEBPACK FOOTER //
// ./app/components/support/support.service.js